export default "__VITE_ASSET__YcabXmxM__"